const tooltips = {
  jegyellenorzes: 'Jegyek érvényességét lehet ellenőrizni a menüpontban.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
